import { combineReducers } from '@reduxjs/toolkit';

import accessGroupsReducer from './accessGroups/accessGroupsSlice';
import auditReducer from './audit/auditSlice';
import cardsReducer from './cards/cardsSlice';
import cardtimesReducer from './cardtimes/cardtimesSlice';
import clientConfigurationReducer from './clientConfiguration/clientConfigurationSlice';
import commentsReducer from './comments/commentsSlice';
import contractsReducer from './contracts/contractsSlice';
import contractsDetailsReducer from './contractsDetails/contractsDetailsSlice';
import customersReducer from './customers/customersSlice';
import destPointReducer from './destPoint/destPointSlice';
import destPointDetailsReducer from './destPointDetails/destPointDetailsSlice';
import driversReducer from './drivers/driversSlice';
import dynamicTablesReducer from './dynamicTables/dynamicTablesSlice';
import headerReducer from './header/headerSlice';
import historyReducer from './history/historySlice';
import identityReducer from './identity/identitySlice';
import inventorizationReducer from './inventorization/inventorizationSlice';
import iotReducer from './iot/iotSlice';
import ivazReducer from './ivaz/ivazSlice';
import licensesReducer from './licenses/licensesSlice';
import ordersReducer from './orders/ordersSlice';
import productsReducer from './products/productsSlice';
import productsGroupsReducer from './productsGroups/productsGroupsSlice';
import reportsReducer from './reports/reportsSlice';
import requestedMsgReducer from './requestedMsg/requestedMsgSlice';
import resultsReducer from './results/resultsSlice';
import settingsReducer from './settings/settingsSlice';
import smartSearchReducer from './smartSearch/smartSearchSlice';
import spyReducer from './spy/spySlice';
import taskSchedulerReducer from './taskScheduler/taskSchedulerSlice';
import toastReducer from './toast/toastSlice';
import userConfigurationReducer from './userConfiguration/userConfigurationSlice';
import usersReducer from './users/usersSlice';
import vehiclesReducer from './vehicles/vehiclesSlice';
import warehouseReducer from './warehouse/warehouseSlice';
import weightingsReducer from './weightings/weightingsSlice';

const rootReducer = combineReducers({
	identity: identityReducer.reducer,
	users: usersReducer.reducer,
	accessGroups: accessGroupsReducer.reducer,
	results: resultsReducer.reducer,
	clientConfiguration: clientConfigurationReducer,
	userConfiguration: userConfigurationReducer,
	toast: toastReducer,
	reports: reportsReducer,
	comments: commentsReducer,
	ivaz: ivazReducer,
	history: historyReducer,
	header: headerReducer,
	smartSearch: smartSearchReducer,
	customers: customersReducer.reducer,
	orders: ordersReducer.reducer,
	drivers: driversReducer.reducer,
	vehicles: vehiclesReducer.reducer,
	weightings: weightingsReducer.reducer,
	products: productsReducer.reducer,
	productsGroups: productsGroupsReducer.reducer,
	spy: spyReducer.reducer,
	destPoint: destPointReducer.reducer,
	destPointDetails: destPointDetailsReducer.reducer,
	cards: cardsReducer.reducer,
	cardtimes: cardtimesReducer.reducer,
	settings: settingsReducer.reducer,
	licenses: licensesReducer.reducer,
	audit: auditReducer.reducer,
	warehouse: warehouseReducer.reducer,
	inventorization: inventorizationReducer.reducer,
	IoT: iotReducer.reducer,
	contracts: contractsReducer.reducer,
	contractsDetails: contractsDetailsReducer.reducer,
	dynamicTables: dynamicTablesReducer.reducer,
	taskScheduler: taskSchedulerReducer.reducer,
	requestedMsg: requestedMsgReducer.reducer,
});

export default rootReducer;
